import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Swal from "sweetalert2";
import { GetASD, GroupByForeignKey, GroupByPropCheck, GroupByProps } from "../Actions/GetContainer";
import { EjercicioByRange } from "../Helper/EjercicioByRange";
import { PeriodoSelect } from "../../Ventas/FacturacionMaquinaria/PeriodoSelect";
import { AgruparLineasER } from "../Actions/ActionEstadoResultados";

const FiltroDashboard = ({
  onExecute,
  boxState,
  onBoxChange,
  cargarfiltros = true,
  sucursales,
  mostraradr = true,
  mostrarsucursal = true,
  mostrardepartamento = false,
}) => {
  const storedState = JSON.parse(localStorage.getItem('dashboard_filtro')) || {};
  const [openModal, setOpenModal] = useState(false);
  const [state, setState] = useState({
    // linea: 0,
    adr: [],
    sucursal: [],
    departamento: [],
    ejercicio: storedState.ejercicio || new Date().getFullYear(),
    periodoinicio: storedState.periodoinicio || 1,
    periodofin: storedState.periodofin || new Date().getMonth() + 1,
    periodo: new Date().getMonth() + 1
  });
  const {
    data,
    adr,
    sucursal,
    departamento,
  } = state;
  const onOpenModal = () => {
    const container = document.getElementById("mdlFiltros-modal");
    if (!container) return;
    if (openModal) {
      container.style.display = "flex";
      setOpenModal(false);
    } else {
      container.style.display = "none";
      setOpenModal(true);
    }
  };

  const capitalizeWords = (text) => {
    return text
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  useEffect(() => {
    // onClose();
    if (cargarfiltros)
      GetASD()
        .then((res) => {
          setState({
            ...state,
            data: res,
          });
          onBoxChange("pv", {
            adr: GroupByProps(res, ["idadr", "adr"]),
            sucursal: [],
            departamento: [],
          });
        })
        .catch((err) => console.log(err));
  }, []);

  const accesosPermitidos = new Set(
    sucursales?.map(s => `${s.idsucursal}-${s.iddepartamento}`)
  );
  const idsSucursalPermitidas = [...new Set(sucursales?.map(s => String(s.idsucursal)))];

  const sucursalFiltrada = sucursal.filter(item => idsSucursalPermitidas.includes(item.idsucursal));

  const departamentosFiltrados = data?.filter(d => accesosPermitidos.has(`${d.idsucursal}-${d.iddepartamento}`))
    .reduce((acc, curr) => {
      if (!acc.some(dep => dep.iddepartamento === curr.iddepartamento)) {
        acc.push({ iddepartamento: curr.iddepartamento, departamento: curr.departamento });
      }
      return acc;
    }, []);

  const adrFiltrado = adr?.filter(itemAdr =>
    data.some(d => String(d.idadr) === String(itemAdr.idadr) && idsSucursalPermitidas.includes(String(d.idsucursal)))
  );


  useEffect(() => {
    var newadr = GroupByPropCheck(data, ["idadr", "adr"]);
    var newsucursal = GroupByPropCheck(data, ["idsucursal", "sucursal"], false);
    var newdepartamento = GroupByPropCheck(
      data,
      ["iddepartamento", "departamento"],
      false
    );
    setState({
      ...state,
      adr: newadr,
      sucursal: newsucursal,
      departamento: newdepartamento,
    });
  }, [data]);

  const onCargar = () => {
    if (
      state.ejercicio === undefined ||
      state.ejercicio === null ||
      state.ejercicio === ""
    ) {
      Swal.fire(
        "DASHBOARD FINANCIERO",
        "Favor de seleccionar el ejercicio",
        "warning"
      );
      return;
    }
    if (
      state.periodoinicio === undefined ||
      state.periodoinicio === null ||
      state.periodoinicio === ""
    ) {
      Swal.fire(
        "DASHBOARD FINANCIERO",
        "Favor de seleccionar el periodo de inicio",
        "warning"
      );
      return;
    }
    if (
      state.periodofin === undefined ||
      state.periodofin === null ||
      state.periodofin === ""
    ) {
      Swal.fire(
        "DASHBOARD FINANCIERO",
        "Favor de seleccionar el periodo final",
        "warning"
      );
      return;
    }
    onOpenModal();
    onExecute(
      state.ejercicio,
      state.periodoinicio,
      state.periodofin,
      state.sucursal,
      state.adr
    )
      .then((result) => {
    })
  .catch((error) => {
    Swal.fire("RESUMEN DE CARTERA MENSUAL", JSON.stringify(error), "error");
  });
  };

const labelclick = ({ target }) => {
  target.parentNode.firstChild.click();
};

const selectedClick = ({ target }, index) => {
  switch (target.name) {
    case "chk-adr":
      var newarray = adr;
      newarray[index].checked = target.checked;

      var newarrarsucursal = [];
      var newarraydepartamento = [];
      var adrActive = [];
      newarray.forEach((item) => {
        if (item.checked) {
          adrActive = [...adrActive, { idadr: item.idadr, adr: item.adr }];
          newarrarsucursal = newarrarsucursal.concat(
            GroupByForeignKey(data, "idadr", item.idadr, [
              "idsucursal",
              "sucursal",
            ])
          );
          newarraydepartamento = newarraydepartamento.concat(
            GroupByForeignKey(data, "idadr", item.idadr, [
              "iddepartamento",
              "departamento",
            ])
          );
        }
      });
      onBoxChange("pv", {
        adr: adrActive,
        sucursal: [],
        departamento: [],
      });
      setState({
        ...state,
        adr: newarray,
        sucursal:
          newarrarsucursal.length == 0
            ? GroupByPropCheck(data, ["idsucursal", "sucursal"], false)
            : GroupByPropCheck(
              newarrarsucursal,
              ["idsucursal", "sucursal"],
              false
            ),
        departamento:
          newarraydepartamento.length == 0
            ? GroupByPropCheck(
              data,
              ["iddepartamento", "departamento"],
              false
            )
            : GroupByPropCheck(
              newarraydepartamento,
              ["iddepartamento", "departamento"],
              false
            ),
      });
      break;
    case "chk-sucursal":
      var newarray = sucursalFiltrada;
      newarray[index].checked = target.checked;

      var newarraydepartamento = [];
      var sucursalactiva = [];
      newarray.forEach((item) => {
        if (item.checked) {
          sucursalactiva = [
            ...sucursalactiva,
            { idsucursal: item.idsucursal, sucursal: item.sucursal },
          ];
          newarraydepartamento = newarraydepartamento.concat(
            GroupByForeignKey(data, "idsucursal", item.idsucursal, [
              "iddepartamento",
              "departamento",
            ])
          );
        }
      });
      onBoxChange("pv", {
        adr: boxState.pv.adr,
        sucursal: sucursalactiva,
        departamento: [],
      });
      setState({
        ...state,
        sucursal: newarray,
        departamento:
          newarraydepartamento.length == 0
            ? GroupByPropCheck(
              data,
              ["iddepartamento", "departamento"],
              false
            )
            : GroupByPropCheck(
              newarraydepartamento,
              ["iddepartamento", "departamento"],
              false
            ),
      });
      break;
    default:
      var newarray = departamento;
      var departamentoactivo = [];
      newarray[index].checked = target.checked;

      newarray.forEach((item) => {
        if (item.checked) {
          departamentoactivo = [
            ...departamentoactivo,
            {
              iddepartamento: item.iddepartamento,
              departamento: item.departamento,
            },
          ];
        }
      });
      onBoxChange("pv", {
        adr: boxState.pv.adr,
        sucursal: boxState.pv.sucursal,
        departamento: departamentoactivo,
      });
      setState({
        ...state,
        departamento: newarray,
      });
      break;
  }
};

const onChange = ({ target }) => {
  setState({
    ...state,
    [target.name]: target.value,
  });
  onBoxChange(target.name, target.value);
};

// console.log(boxState)

return (
  <div className="filtros-pedidos-facturados">
    <div className="reporte-buro-credito-filtrado" onClick={onOpenModal}>
      <FilterAltIcon /> Filtrar
    </div>
    <div className="mdl-filtro-resumen-cartera" id="mdlFiltros-modal">
      <PlantillaScreen
        titulo={`Filtro`}
        className_main={1}
        className={"modal-filtro-resumen-cartera-mensual"}
      >
        <div className="filtro-soy-el-titulo-header" onClick={onOpenModal}>
          X
        </div>
        <div className="modal-filtro-resumen-cartera-mensual-container">
          <div className="modal-filtro-resumen-cartera-mensual-container-filtros">
            <div className="filtro-tiempo-tipo">
              <div className="filtro-group">
                <label>Ejercicio</label>
                <EjercicioByRange
                  name="ejercicio"
                  value={state.ejercicio}
                  onChange={onChange}
                />
                    <label>Periodo</label>
                    <PeriodoSelect
                      name="periodoinicio"
                      value={state.periodoinicio}
                      onChange={onChange}
                    />
                    <label>Periodo Fin</label>
                    <PeriodoSelect
                      name="periodofin"
                      value={state.periodofin}
                      onChange={onChange}
                    />
              </div>
              <div
                className="mdlFiltros-modal-acciones-guardar"
                onClick={onCargar}
              >
                Cargar
              </div>
            </div>
            {cargarfiltros === false || mostraradr === false ? (
              <div></div>
            ) : (
              <div className="filtro-adr">
                <div className="title title-adr">Región</div>
                {/* {adr.map((item, index) => ( */}
                {adrFiltrado?.map((item, index) => (
                  <div key={`${item}-${index}`} className="chk-groups">
                    <input
                      type="checkbox"
                      name="chk-adr"
                      onChange={(e) => selectedClick(e, index)}
                      checked={item.checked}
                      value={item.idadr}
                    />
                    <label>{capitalizeWords(item.adr)}</label>
                  </div>
                ))}
              </div>
            )}
            {cargarfiltros === false || mostrarsucursal === false ? (
              <div></div>
            ) : (
              <div className="filtro-sucursal">
                <div className="title title-sucursal">Sucursal</div>
                {sucursalFiltrada?.map((item, index) => (
                  <div key={`${item}-${index}`} className="chk-groups">
                    <input
                      type="checkbox"
                      name="chk-sucursal"
                      className="my-checkbox"
                      onChange={(e) => selectedClick(e, index)}
                      checked={item.checked}
                      value={item.idsucursal}
                    />
                    <label onClick={labelclick}>{capitalizeWords(item.sucursal)}</label>
                  </div>
                ))}
              </div>
            )}
            {/* {cargarfiltros === false || mostrardepartamento === false ? (
                <div></div>
              ) : (
                <div className="filtro-departamento">
                  <div className="title">Departamento</div>
                  {departamentosFiltrados?.map((item, index) => (
                    <div key={`${item.iddepartamento}-${index}`} className="chk-groups">
                      <input
                        type="checkbox"
                        name="chk-departamento"
                        onChange={(e) => selectedClick(e, index)}
                        checked={item.checked}
                        value={item.iddepartamento}
                      />
                      <label>{capitalizeWords(item.departamento)}</label>
                    </div>
                  ))}
                </div>
              )} */}
          </div>
          <div className="mdlFiltros-modal-acciones">
          </div>
        </div>
      </PlantillaScreen>
    </div>
  </div>
);
};

export default FiltroDashboard;